/**
 * Removes extra spaces between letters in a string.
 *
 * This function takes a string input and replaces any sequences
 * of two or more consecutive spaces with a single space. It also
 * trims any leading or trailing spaces from the string.
 *
 * @param {string} str - The input string from which to remove extra spaces.
 * @returns {string} - The resulting string with extra spaces removed.
 *
 * @example
 * const result = removeExtraSpaces("bar  foo");
 * console.log(result); // Output: "bar foo"
 */
export const removeExtraSpaces = (str: string): string => {
  return str.replace(/\s{2,}/g, ' ').trim();
};

